<template>
  <div class="container">
    <SystemCard :cardList="cardList"/>
  </div>
</template>

<script>
  // @ is an alias to /src
  import SystemCard from './common/SystemCard'

  export default {
    name: 'Home',
    components: {
      SystemCard
    },
    data () {
      return {
        cardList: []
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        this.getData()
      },
      async getData () {
        let { data } = await this.$http.queryCurrentUserPlatInfoList()
        this.cardList = data
      }
    }
  }
</script>

<style scoped lang="less">
  @import "~@/common/style/base.less";
</style>
